// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3R_Tw","checkboxCol":"Table_checkboxCol__3oynV","emailCol":"Table_emailCol__3Z41c","actionCol":"Table_actionCol__Xr97p"};